import { render, staticRenderFns } from "./ViewCandidateSummary.vue?vue&type=template&id=45933471&scoped=true"
import script from "./ViewCandidateSummary.vue?vue&type=script&lang=ts"
export * from "./ViewCandidateSummary.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidateSummary.vue?vue&type=style&index=0&id=45933471&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45933471",
  null
  
)

export default component.exports